import React, { ReactNode } from "react";
import styled from "styled-components";

import { getDocumentUrl } from "@/config";
import { log } from "@/utils/logger";

type ExceptionProps = {
  onDestroy: () => void;
  children?: ReactNode;
};

type ExceptionState = {
  error: Error | null;
  errorInfo: any;
};

export default class Exception extends React.PureComponent<
  ExceptionProps,
  ExceptionState
> {
  constructor(props: ExceptionProps) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: any): void {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    if (__PROD__) {
      log.error("Error during rendering interaction: " + error.message, {
        error,
        x_referrer: getDocumentUrl(),
      });
      this.props.onDestroy();
    }
  }

  public render(): React.JSX.Element {
    const { error } = this.state;

    if (error) {
      return (
        <ErrorWrapper>
          <h1>{error.message}</h1>
          {__DEV__ && <pre>{error.stack}</pre>}
        </ErrorWrapper>
      );
    }

    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

const ErrorWrapper = styled.div<any>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-family: ${(props: any) =>
    Object.keys(props.theme).length > 0
      ? props.theme.globals.fontFamily
      : `-apple-system, BlinkMacSystemFont, Helvetica, Arial, sans-serif`};
  padding: ${(props: any) =>
    Object.keys(props.theme).length > 0
      ? props.theme.spacing.desktop.s500
      : 25}px;
  background-color: "#EEE";
  max-width: ${(props: any) =>
    Object.keys(props.theme).length > 0
      ? props.theme.globals.maxInteractionWidth
      : "580px"};
  min-height: ${(props: any) =>
    Object.keys(props.theme).length > 0
      ? props.theme.globals.minInteractionHeight
      : "470px"};
  margin: ${(props: any) =>
      Object.keys(props.theme).length > 0
        ? props.theme.spacing.desktop.s500
        : 20}px
    auto;
  h1 {
    font-size: ${(props: any) =>
      Object.keys(props.theme).length > 0
        ? props.theme.typography.h700
        : "22px"};
    margin-bottom: 15px;
    text-align: center;
  }
  pre {
    width: 95%;
    max-height: 250px;
    font-size: 11px;
    overflow-x: scroll;
    overflow-y: auto;
    background: white;
    padding: 10px;
    border-radius: 5px;
  }
`;
